import React from 'react';
import { IAppointment } from '../../../../../api/types';
import { TitleWrapper } from '../styles';
import { useDetailsItemStyles } from '../DetailsItem/styles';
import { Divider } from '@mui/material';
import { CompanyName, CompanyNameValue, Details, Title } from './styles';
import { TruncatedText } from '../../../../../components/TruncatedText/TruncatedText';

export const CustomerInfo: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<{ payload: IAppointment }>>
> = ({ payload }) => {
  const { classes } = useDetailsItemStyles();
  const customerInformation = payload.customerInformation;
  const email = customerInformation?.email ?? '';
  const phoneNumber = customerInformation?.phoneNumber ?? '';

  return (
    <div>
      <TitleWrapper>Customer Information</TitleWrapper>
      <Details>
        <div className={classes.title}>
          {customerInformation ? (
            <TruncatedText text={customerInformation.fullName ?? ''} />
          ) : (
            'DMS missing Customer Information'
          )}
        </div>
        <div className={classes.text}>
          {email ? <TruncatedText text={email} /> : null}
          {phoneNumber ? <div>{phoneNumber}</div> : null}
        </div>
      </Details>
      {customerInformation?.dmsId ? <Title>Customer ID: {customerInformation.dmsId}</Title> : null}
      {customerInformation?.companyName ? (
        <CompanyName>
          <span>Company Name:</span>
          <CompanyNameValue>
            <TruncatedText text={customerInformation.companyName} />
          </CompanyNameValue>
        </CompanyName>
      ) : null}
      <Divider style={{ marginBottom: 24 }} />
    </div>
  );
};
